import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Lambda } from 'aws-sdk';
import { EntConfig } from '../../models/entConfig.model';
import { Closure } from '../../models/closure.model';
import { AuthService } from '../auth/auth.service';



@Injectable({
  providedIn: 'root'
})

export class ConfigService {
  functionName = environment.dynamoLambdaName;
  configList: string[];
  activeLOB: string = null;
  activeLOBLife: string = 'life';
  activeDnis: string = "";
  activeConfig: string;
  activeConfigData:any = new EntConfig();
  oldConfigData:any = new EntConfig();
  userName: string;
  queueNamesList: Array<any>;
  configKeyTitle = 'Config Key';
  lang = 'en-US';
  newLang: string;
  highVolumeActive = false;
  newHighVolume: {
    active: true,
    message: ''
  };
  oldHighVolume: {
    active: false,
    message: ''
  };
  configKeyMap = {
    health: 'Queue Name',
    fnol: 'DNIS',
    life: 'Queue Name',
    auto: 'Queue Name',
    claims: 'Queue Name'
  }

  reqMessageKeys = {
    fnol: [
      'agentsMessage',
      'greetingMessage',
      'highVolume',
      'holdMessage1',
      'holdMessage2',
      'holdMessage3',
      'hoursMessage',
      'recordingMessage',
      'forceToVoicemail',
      'transferToVoicemail'
    ],
    health: [
      'agentsMessage',
      'greetingMessage',
      'highVolume',
      'holdMessage1',
      'holdMessage2',
      'holdMessage3',
      'hoursMessage',
      'recordingMessage',
      'forceToVoicemail',
      'transferToVoicemail'
    ],
    life: [
      'agentsMessage',
      'greetingMessage',
      'highVolume',
      'holdMessage1',
      'holdMessage2',
      'holdMessage3',
      'hoursMessage',
      'recordingMessage',
      'forceToVoicemail',
      'transferToVoicemail'
    ],
    auto: [
      'agentsMessage',
      'greetingMessage',
      'highVolume',
      'holdMessage1',
      'holdMessage2',
      'holdMessage3',
      'hoursMessage',
      'recordingMessage',
      'forceToVoicemail',
      'transferToVoicemail'
    ],
    claims: [
      'agentsMessage',
      'greetingMessage',
      'highVolume',
      'holdMessage1',
      'holdMessage2',
      'holdMessage3',
      'hoursMessage',
      'recordingMessage',
      'forceToVoicemail',
      'transferToVoicemail'
    ]
  }

  languages = [
    "en-US",
    "es-US",
    "es-ES"
  ]

  selectedQueueName: string;
  selectedQueueNameOverflow: string;

  async getNewQueueName(objectName: string) {
    this.selectedQueueName = this[objectName].ConfigKey;
    if (!this.queueNamesList) {
      await this.getQueueList();
    }
    this.queueNamesList.map(queue => {
      if (queue['queueArn'] === this[objectName].OverflowConfig.queueArn) {
        this.selectedQueueNameOverflow = queue['queueName'];
      }
    });
  }

  setLOB(lob: string) {
    if (this.activeLOB === lob) return null
    this.activeLOB = lob;
    this.activeConfig = '',
    this.configList = [];
    this.activeConfigData = new EntConfig();
    this.oldConfigData = new EntConfig();
  }

  getKeyList(lob: string) {
    let lambda = new Lambda();
    let params = {
      FunctionName: this.functionName,
      Payload: JSON.stringify({
        Operation: 'getKeyList',
        LOB: lob
      })
    }
    return new Promise(async (resolve, reject) => {
      let keyList: any;
      try {
        keyList = await lambda.invoke(params).promise();
      } catch (err) {
        console.error('Get Key List error:', err);
        reject([]);
      }
      let response = JSON.parse((keyList as any).Payload);
        this.configList = JSON.parse(response.body);
        resolve(this.configList);
    })
  }

  setNewConfig() {
    this.activeConfigData = new EntConfig;
    this.activeConfigData.LOB = this.activeLOB;
    this.activeConfigData.MessageConfig.lang = this.newLang;
    this.reqMessageKeys[this.activeLOB].map((key: string) => {
      const msg = {};
      if (key === 'highVolume') {
        msg[this.newLang] = '<speak2></speak2>';
      } else {
        msg[this.newLang] = '<speak></speak>';
      }

      this.activeConfigData.MessageConfig.messages[key] = msg;
    })
    this.oldConfigData = JSON.parse(JSON.stringify(this.activeConfigData)) as EntConfig;
  }

  getQueueList() {

    return new Promise((resolve: any) => {
      let lambda = new Lambda();
      let params = {
        FunctionName: environment.QueuesLambdaName,
        Payload: JSON.stringify({
          operation: 'get'
        })
      }
      lambda.invoke(params, (err, data)=>{
        if (err){
          console.error("Failed to retrieve queues list. Error: ", err)
        }else{
          let response = (data as any);
          console.log("response: ", response);
          response = JSON.parse(response.Payload);
          console.log(response);
          let queues = response.body.queueList;
          this.queueNamesList = [];
          queues.map(x=>{
            if(x.LOB == this.activeLOB){
              x['QueueName'] = x.queueName;
              x['QueueArn'] = x.queueConfig.queueArn;
              this.queueNamesList.push(x);
            }
          });
          console.log("final queueNamesList: ", this.queueNamesList);
        }
        resolve();
      });
    });
  }

  getConfigData(lob: string, configKey: string) {
    this.activeConfig = configKey;
    let lambda = new Lambda();
    let params = {
      FunctionName: this.functionName,
      Payload: JSON.stringify({
        Operation: 'getConfigData',
        ConfigKey: configKey,
        LOB: lob
      })
    }
    return new Promise(async (resolve, reject) => {
      let lambdaResult: any;
      try {
        lambdaResult = await lambda.invoke(params).promise();
      } catch (err) {
        console.error('Get Config Data error:', err);
        reject(err);
      }
      let parse1 = JSON.parse(lambdaResult.Payload)
      let parse1Body = parse1.body
      let parse2 = JSON.parse(parse1Body)
      
      let configData = parse2
      const highVol = configData.MessageConfig.messages.highVolume;
      if (highVol) {
        for (let key of Object.keys(highVol)) {
          if (highVol[key].includes('<speak>')) {
            this.highVolumeActive = true;
          }
        }
      }
      this.setConfigData(configData);
      resolve(configData);
    })
  }

  queueConfigChanged() {
    return !(JSON.stringify(this.activeConfigData.QueueConfig) === JSON.stringify(this.oldConfigData.QueueConfig));
  }

  messageConfigChanged() {
    return !(JSON.stringify(this.activeConfigData.MessageConfig) === JSON.stringify(this.oldConfigData.MessageConfig));
  }

  overflowConfigChanged() {
    return !(JSON.stringify(this.activeConfigData.OverflowConfig) === JSON.stringify(this.oldConfigData.OverflowConfig));
  }

  setConfigData(data: EntConfig) {
    const config = data;
    const dbClosures = data.MessageConfig.closures;
    let appClosures = {};
    for (let key in dbClosures) {
      const closure = dbClosures[key];
      let appClosure = {
        allDay: closure.allDay,
        date: this.formDate(closure),
        endTime: this.displayTime(closure.endTime),
        repeating: closure.repeating,
        startTime: this.displayTime(closure.startTime)
      }
      appClosures[key] = appClosure;
    }
    config.MessageConfig.closures = appClosures;
    const stringData = JSON.stringify(config);
    this.lang = config.MessageConfig.lang;
    const highvol = data.MessageConfig.messages['highVolume'];
    for (let msg in highvol) {
      if (highvol[msg].includes('<speak>')) {
        this.highVolumeActive = true;
      }
    }
    this.activeConfigData = JSON.parse(stringData) as EntConfig;
    this.oldConfigData = JSON.parse(stringData) as EntConfig;
    this.getNewQueueName('activeConfigData');
    return this.activeConfig;
  }

  displayTime(time: string) {
    if (time === "null") {
      return null;
    }
    const result = this.padNum(parseInt(time.slice(0,2)), 2) + ":" + this.padNum(parseInt(time.slice(2,4)), 2);
    return result;
  }

  formDate(closure: Closure) {
    const time = closure.startTime;
    const hours = parseInt(time.slice(0,2)) - 1;
    const minutes = parseInt(time.slice(2,4));
    const dt = new Date(closure.year, closure.month - 1, closure.day, hours, minutes)
    return dt.getFullYear() + '-' + this.padNum((dt.getMonth() + 1), 2) + '-' + this.padNum(dt.getDate(), 2);
  }

  getDateFromString(datestr: string) {
    const year = datestr.slice(0,4);
    const month = datestr.slice(5,7);
    const day = datestr.slice(8,10);
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  }

  padNum(num: number, size: number) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }

  postTimeFormat(time: string) {
    return time.slice(0,2) + time.slice(3,5);
  }

  postConfigData(config: EntConfig, newConfig: boolean) {
    const configCopy = JSON.parse(JSON.stringify(config));
    let {
      ConfigKey,
      LOB,
      QueueConfig,
      MessageConfig,
      OverflowConfig,
      CREATED_D,
      UPDATED_D,
      CREATED_I,
      UPDATED_I
    } = configCopy;
    this.userName = this.authService.username;
    if (!OverflowConfig.transferNumber) {
      OverflowConfig.transferNumber = null
    }
    if (!OverflowConfig.queueArn) {
      OverflowConfig.queueArn = null
    }

    for (let key in MessageConfig.closures) {
      const date = this.getDateFromString(MessageConfig.closures[key].date);
      const day = (date.getDate()).toString();
      const month = (date.getMonth() + 1).toString();
      const year = date.getFullYear().toString();
      MessageConfig.closures[key].day = day;
      MessageConfig.closures[key].month = month;
      MessageConfig.closures[key].year = year;
      MessageConfig.closures[key].startTime = this.postTimeFormat(MessageConfig.closures[key].startTime);
      MessageConfig.closures[key].endTime = this.postTimeFormat(MessageConfig.closures[key].endTime);
    }

    UPDATED_D = Math.floor(Date.now() / 1000).toString();
    UPDATED_I = this.userName;

    if (newConfig || !CREATED_D) {
      CREATED_D = Math.floor(Date.now() / 1000).toString();
      CREATED_I = this.userName;
    }
    let lambda = new Lambda();
    let params = {
      FunctionName: this.functionName,
      Payload: JSON.stringify({
        Operation: 'postConfig',
        ConfigKey: ConfigKey,
        LOB: LOB,
        QueueConfig: QueueConfig,
        MessageConfig: MessageConfig,
        OverflowConfig: OverflowConfig,
        CREATED_D: CREATED_D,
        UPDATED_D: UPDATED_D,
        CREATED_I: CREATED_I,
        UPDATED_I: UPDATED_I
      })
    }
    return new Promise(async (resolve, reject) => {
      let postCall: any;
      try{
        postCall = await lambda.invoke(params).promise();
      } catch(err) {
        console.error('Post Config Error:', err);
        reject(err);
      }
      this.getConfigData(LOB, ConfigKey);
      resolve(postCall);
    })
  }

  updateHighVol(event: any) {
    let active = event['checked'];
    const highVol = this.activeConfigData.MessageConfig.messages['highVolume'];
    for (let key of Object.keys(highVol)) {
        let msg = highVol[key];
        let activated = msg.includes('<speak>');
        if (active && !activated) {
          highVol[key] = '<speak>Enter message here</speak>'
        } else if (!active && activated) {
          highVol[key] = 'null'
        }
    }
  }


  constructor(
    private authService: AuthService
  ) { }
}
